/* ---------------------------------------------------------
   SALEEQA - COLLECTION FILTERS

   Prestige builds filter groups from tags formatted
   Group_Value. A group with only one option is noise, for
   example Type on the Tees collection where everything is a
   tee. This hides those automatically, so Product type only
   appears where it actually narrows something down.
   --------------------------------------------------------- */

(function () {
  'use strict';

  function tidyFilters() {
    var groups = document.querySelectorAll('.CollectionFilters .Collapsible');
    if (!groups.length) return;

    Array.prototype.forEach.call(groups, function (group) {
      var options = group.querySelectorAll('[data-action="toggle-tag"]');
      /* Leave quick links alone, they have no toggle-tag buttons */
      if (!options.length) return;
      group.style.display = options.length < 2 ? 'none' : '';
    });
  }

  window.addEventListener('load', tidyFilters);
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(tidyFilters, 300);
    setTimeout(tidyFilters, 1200);
  });

  /* The drawer contents can be built when it is opened */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-drawer-id="collection-filter-drawer"]')) {
      setTimeout(tidyFilters, 200);
      setTimeout(tidyFilters, 600);
    }
  });
})();
